module.exports = __webpack_public_path__ + "img/geofence.d9435946.png";